import React, { ReactNode } from "react";
import { createPortal } from "react-dom";

import { DraggableProvided, DraggableStateSnapshot } from "react-beautiful-dnd";

// https://github.com/atlassian/react-beautiful-dnd/issues/485#issuecomment-385816391
// workaround for position fixed for draggable
const portal: HTMLElement = document.createElement("div");
document.body.appendChild(portal);

interface DnDChildProps {
  node: ReactNode;
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
}

const DnDChild: React.FC<DnDChildProps> = ({ node, provided, snapshot }) => {
  const child = (
    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
      {node}
    </div>
  );

  if (!snapshot.isDragging) {
    return child;
  }

  return createPortal(child, portal);
};

export default DnDChild;
